import { adminInstance } from "@/api/instance";

export default async function (beautyId) {
  return adminInstance.get(`/beauty/${beautyId}`);
}
